import { useState, useEffect } from "react";
import { useLocation } from "wouter";

export function useNavigation() {
  const [location] = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrollDirection, setScrollDirection] = useState<"up" | "down">("up");
  const [lastScrollY, setLastScrollY] = useState(0);

  // Detect scroll direction
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setScrollDirection("down");
      } else {
        setScrollDirection("up");
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === "/portal/home" || path === "/portal") {
      return location === "/portal/home" || location === "/portal" || location === "/portal/dashboard";
    }
    return location.startsWith(path);
  };

  return {
    location,
    menuOpen,
    setMenuOpen,
    scrollDirection,
    isActive,
    showBottomNav: scrollDirection === "up" || lastScrollY < 50,
  };
}
